export const TopDestinations = {
    REQUEST_TOP_DESTINATIONS: 'REQUEST_TOP_DESTINATIONS',
    RECEIVE_TOP_DESTINATIONS: 'RECEIVE_TOP_DESTINATIONS',
};
